import { defineMessages } from 'react-intl';
export default defineMessages({
  minevalidOnToday: {
    id: 'mine.validOnToday',
    defaultMessage: '当日有效',
  },
  minenoCoupon: {
    id: 'mine.noCoupon',
    defaultMessage: '暂无优惠券',
  },
  mineprivilege: {
    id: 'mine.privilege',
    defaultMessage: '特权',
  },
  minegetPoints: {
    id: 'mine.getPoints',
    defaultMessage: '每消费{currency}{price}可获得{point}个积分',
  },
  minegetPoints1: {
    id: 'mine.getPoints1',
    defaultMessage: '每消费{currency}{price}可获得{point}个捞币',
  },
  mineusePointsRules: {
    id: 'mine.usePointsRules',
    defaultMessage: '积分使用无上限',
  },
  mineusePointsRules1: {
    id: 'mine.usePointsRules1',
    defaultMessage: '捞币使用无上限',
  },
  minepointsDeduction: {
    id: 'mine.pointsDeduction',
    defaultMessage: '单次最多可抵扣{point}个积分',
  },
  minepointsDeduction1: {
    id: 'mine.pointsDeduction1',
    defaultMessage: '单次最多可抵扣{point}个捞币',
  },
  minepointsDeductionRule1: {
    id: 'mine.pointsDeductionRule1',
    defaultMessage: '单次最多可抵用订单金额的{percent}%',
  },
  minepointsDeductionRule2: {
    id: 'mine.pointsDeductionRule2',
    defaultMessage: '每{point}个积分可抵扣{currency}{price}',
  },
  minepointsDeductionRule3: {
    id: 'mine.pointsDeductionRule3',
    defaultMessage: '每{point}个捞币可抵扣{currency}{price}',
  },
  mineNull: {
    id: 'mine.Null',
    defaultMessage: '暂无',
  },
  minefindNull: {
    id: 'mine.findNull',
    defaultMessage: '未找到记录',
  },
  minekrySupport: {
    id: 'mine.krySupport',
    defaultMessage: '客如云提供技术支持',
  },
  minecardId: {
    id: 'mine.cardId',
    defaultMessage: '卡号',
  },
  minecardPassword: {
    id: 'mine.cardPassword',
    defaultMessage: '密码',
  },
  minenextStep: {
    id: 'mine.nextStep',
    defaultMessage: '下一步',
  },
  mineVerify: {
    id: 'mine.Verify',
    defaultMessage: '验证中，请稍后……',
  },
  mineIDInputPrompt: {
    id: 'mine.IDInputPrompt',
    defaultMessage: '请输入16位数的卡号',
  },
  minePWInputPrompt: {
    id: 'mine.PWInputPrompt',
    defaultMessage: '请输入8位数的密码',
  },
  minedynamicCode: {
    id: 'mine.dynamicCode',
    defaultMessage: '动态会员码',
  },
  minepayPrompt: {
    id: 'mine.payPrompt',
    defaultMessage: '需要会员余额支付时，请向店员出示',
  },
  minereFresh: {
    id: 'mine.reFresh',
    defaultMessage: '每{refreshTime}秒自动刷新',
  },
  minescanPrompt: {
    id: 'mine.scanPrompt',
    defaultMessage: '如遇扫码失败请将屏幕调至最亮重新扫码',
  },
  minePrice: {
    id: 'mine.Price',
    defaultMessage: '售价',
  },
  mineselectRecharge: {
    id: 'mine.selectRecharge',
    defaultMessage: '选择储值门店',
  },
  minecomfirm: {
    id: 'mine.comfirm',
    defaultMessage: '确定',
  },
  minemeCenter: {
    id: 'mine.meCenter',
    defaultMessage: '个人中心',
  },
  minedisabledVIP: {
    id: 'mine.disabledVIP',
    defaultMessage: '会员已停用',
  },
  minebindPN: {
    id: 'mine.bindPN',
    defaultMessage: '绑定手机后查看',
  },
  minecheck: {
    id: 'mine.check',
    defaultMessage: '查看明细',
  },
  minemyPoints: {
    id: 'mine.myPoints',
    defaultMessage: '我的积分',
  },
  mineshowPoints: {
    id: 'mine.showPoints',
    defaultMessage: '{value}分',
  },
  mineexchangeGift: {
    id: 'mine.exchangeGift',
    defaultMessage: '兑换礼品',
  },
  minemyBalance: {
    id: 'mine.myBalance',
    defaultMessage: '我的余额',
  },
  minename: {
    id: 'mine.name',
    defaultMessage: '姓名',
  },
  mineinputName: {
    id: 'mine.inputName',
    defaultMessage: '请输入姓名',
  },
  mineSex: {
    id: 'mine.Sex',
    defaultMessage: '性别',
  },
  mineBirthday: {
    id: 'mine.Birthday',
    defaultMessage: '生日',
  },
  mineexchangePW: {
    id: 'mine.exchangePW',
    defaultMessage: '修改密码',
  },
  minePN: {
    id: 'mine.PN',
    defaultMessage: '手机号',
  },
  minegotoBind: {
    id: 'mine.gotoBind',
    defaultMessage: '去绑定',
  },
  mineUnBind: {
    id: 'mine.UnBind',
    defaultMessage: '未绑定',
  },
  mineexchangePN: {
    id: 'mine.exchangePN',
    defaultMessage: '修改手机号',
  },
  mineSave: {
    id: 'mine.Save',
    defaultMessage: '保存',
  },
  mineLogout: {
    id: 'mine.Logout',
    defaultMessage: '注销',
  },
  minevipProcess: {
    id: 'mine.vipProcess',
    defaultMessage: '成长值：',
  },
  minegotoMeCenter: {
    id: 'mine.gotoMeCenter',
    defaultMessage: '查看订单或优惠券？前往个人中心',
  },
  mineaddToWxWallet: {
    id: 'mine.addToWxWallet',
    defaultMessage: '加入微信卡包',
  },
  minemyGrade: {
    id: 'mine.myGrade',
    defaultMessage: '我的等级',
  },
  mineshowMyPoints: {
    id: 'mine.showMyPoints',
    defaultMessage: '我的积分',
  },
  mineshowMyPoints1: {
    id: 'mine.showMyPoints1',
    defaultMessage: '我的捞币',
  },
  minemyPrivilege: {
    id: 'mine.myPrivilege',
    defaultMessage: '我的特权',
  },
  mineloading: {
    id: 'mine.loading',
    defaultMessage: '正在加载...',
  },
  mineCheckOrder: {
    id: 'mine.CheckOrder',
    defaultMessage: '查看订单或优惠券？',
  },
  mineGoto: {
    id: 'mine.Goto',
    defaultMessage: '前往',
  },
  mineVipCard: {
    id: 'mine.VipCard',
    defaultMessage: '会员卡',
  },
  mineVipCharge: {
    id: 'mine.Charge',
    defaultMessage: '会员充值',
  },
  mineAddress: {
    id: 'mine.Address',
    defaultMessage: '地址管理',
  },
  minePointsShop: {
    id: 'mine.PointsShop',
    defaultMessage: '积分商城',
  },
  mineBindWX: {
    id: 'mine.BindWX',
    defaultMessage: '绑定微信号',
  },
  mineBindAli: {
    id: 'mine.BindAli',
    defaultMessage: '绑定支付宝',
  },
  mineSettings: {
    id: 'mine.Settings',
    defaultMessage: '设置',
  },
  mineVipRigster: {
    id: 'mine.VipRigster',
    defaultMessage: '会员注册',
  },
  mineIHaveID: {
    id: 'mine.IHaveID',
    defaultMessage: '我有卡号',
  },
  minePoints: {
    id: 'mine.Points',
    defaultMessage: '分',
  },
  mineRecharge: {
    id: 'mine.Recharge',
    defaultMessage: '充值',
  },
  mineStations: {
    id: 'mine.Stations',
    defaultMessage: '张',
  },
  mineVipLevelGetPointsRule: {
    id: 'mineVipLevelGetPointsRule',
    defaultMessage:
      '每消费{currency}{consumeValue}可获得{consumeGainValue}个积分',
  },
  mineVipLevelGetPointsRule1: {
    id: 'mineVipLevelGetPointsRule1',
    defaultMessage:
      '每消费{currency}{consumeValue}可获得{consumeGainValue}个捞币',
  },
  mineVipLevelCannotGetPointsRule: {
    id: 'mineVipLevelCannotGetPointsRule',
    defaultMessage: '该等级不可积分',
  },
  mineVipLevelCannotGetPointsRule1: {
    id: 'mineVipLevelCannotGetPointsRule1',
    defaultMessage: '该等级不能获得捞币',
  },
  mineVipLevelPointsDiscountRule: {
    id: 'mineVipLevelPointsDiscountRule',
    defaultMessage:
      '每{exchangeIntegralValue}个积分可抵扣{currency}{exchangeCashValue} {integralConfig}',
  },
  mineVipLevelPointsDiscountRule1: {
    id: 'mineVipLevelPointsDiscountRule1',
    defaultMessage:
      '每{exchangeIntegralValue}个捞币可抵扣{currency}{exchangeCashValue} {integralConfig}',
  },
  mineVipLevelVipPrivilege: {
    id: 'mineVipLevelVipPrivilege',
    defaultMessage: '会员特权',
  },
  mineSettingWechat: {
    id: 'mineSetting.Wechat',
    defaultMessage: '微信号',
  },
  mineSettingAlipay: {
    id: 'mineSetting.Alipay',
    defaultMessage: '支付宝',
  },
  mineSettingWechatMiniProgram: {
    id: 'mineSetting.WechatMiniProgram',
    defaultMessage: '微信小程序',
  },
  mineVipLevelVipTitle: {
    id: 'mineVipLevel.VipTitle',
    defaultMessage: '会员特权',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/mine/index.js